import { useCallback, useState } from "react";

import { useExtensionPromotionEffect } from "app/custom-hooks/useExtensionPromotionEffect";
import { isEligibleForExtensionPromotion } from "app/UtilitiesAndConstants/UtilityFunctions/extensionPromotion";
import {
    extensionPromotionSourceMap,
    getSimilarwebExtensionStoreUrl,
} from "app/UtilitiesAndConstants/UtilityFunctions/extensionStoreUrl";

import { SECOND_LAND } from "../constants";
import {
    trackSecondLandExtensionClick,
    trackSecondLandExtensionClose,
    trackSecondLandExtensionShow,
} from "../tracking";
import { registerLand } from "../utils/landTracking";
import { arePreferencesReady } from "../utils/preferencesReady";
import {
    hasSeenSecondLandExtensionPromo,
    markSecondLandExtensionPromoSeen,
    markSecondLandExtensionPromoShownThisSession,
    wasSecondLandExtensionPromoShownThisSession,
} from "../utils/promoSeenStorage";

type UseSecondLandExtensionModalResult = {
    isOpen: boolean;
    handleClose: () => void;
    handleCtaClick: () => void;
};

export const useSecondLandExtensionModal = (): UseSecondLandExtensionModalResult => {
    const [isOpen, setIsOpen] = useState(false);

    useExtensionPromotionEffect(
        () => {
            if (!arePreferencesReady()) {
                return false;
            }

            if (wasSecondLandExtensionPromoShownThisSession() || hasSeenSecondLandExtensionPromo()) {
                return false;
            }

            if (!isEligibleForExtensionPromotion()) {
                return false;
            }

            return registerLand() === SECOND_LAND;
        },
        () => {
            markSecondLandExtensionPromoShownThisSession();
            markSecondLandExtensionPromoSeen();
            setIsOpen(true);
            trackSecondLandExtensionShow();
        },
    );

    const handleClose = useCallback(() => {
        setIsOpen(false);
        trackSecondLandExtensionClose();
    }, []);

    const handleCtaClick = useCallback(() => {
        trackSecondLandExtensionClick();
        window.open(
            getSimilarwebExtensionStoreUrl(extensionPromotionSourceMap.landOnPro),
            "_blank",
            "noopener,noreferrer",
        );
        setIsOpen(false);
    }, []);

    return { isOpen, handleClose, handleCtaClick };
};
